export default Object.freeze({
    PROVOZOVNA: 'provozovna',
    VEDENI: 'vedeni',
    VEDENI_STREET: 'vedeni_street',
});
